import React, { useCallback } from 'react';
import { useHistory } from 'react-router';
import { ROUTES } from '../routes/routes';
import Button from './Button';

export default function CreatePageButton() {
    const history = useHistory();
    const handleClick = useCallback(() => history.push(ROUTES.PAGES_NEW), [history]);
    return (
        <Button onClick={handleClick} kind="tertiary">
            Create Pricing Page
        </Button>
    );
}
